<template lang="pug">
  .dashboard-container
    Toolbar
    b-container
      .header.mb-2
        .header-body
          h6.header-pretitle
            | {{ greeting }}
          h2.header-title
            | Dashboard
          b-row.mt-4
            b-col(cols="12")
              b-nav(tabs)
                b-nav-item(:to="{name: 'organizations'}", v-if="$can('read', 'organization')") Organizaciones
                b-nav-item(:to="{name: 'accounts'}") Cuentas
                //b-nav-item(:to="{name: 'subscriptions'}", v-if="$can('read', 'subscription-view')") Suscripciones
                b-nav-item(:to="{name: 'admin_user'}") {{user_name || 'Mi usuario'}}
                b-nav-item(:to="{name: 'Auth Shopify Account'}", v-if="$route.name == 'Auth Shopify Account'") Shopify
      router-view
</template>

<script>
import Toolbar from '../../components/Toolbar.vue'

export default {
  data () {
    return {
    }
  },
  computed: {
    greeting () {
      return `Hola, ${this.user_name}`
    },
    user_name () {
      return this.getCurrentUser() && this.getCurrentUser().first_name ? this.getCurrentUser().first_name : ''
    }
  },
  methods: {
  },
  mounted() {
  },
  components: { Toolbar }
}
</script>

<style lang="scss" scoped>
</style>
